module.exports = __webpack_public_path__ + "img/front_15.00c6a9eb.svg";